import styles from './PaymentPanel.module.less';
import Icon from '@/components/common/Icon';
import Button from '@/components/common/Button';
import StatusView from '@/components/common/StatusView';

export type QRMaskStatus = 'loading' | 'expired' | 'failed' | null;

interface QRMaskProps {
    status: QRMaskStatus;
    /** failed 态展示的失败原因文案（由上层 state.reason 传入） */
    reason?: string;
    /** expired/failed 时的点击回调（刷新/重试） */
    onAction?: () => void;
}

/**
 * 二维码蒙层组件
 * 覆盖「二维码 + 倒计时」整个白色容器
 */
export function QRMask({status, reason, onAction}: QRMaskProps) {
    if (!status) return null;

    return (
        <div className={styles.mask}>
            {status === 'loading' && (
                <StatusView
                    size="small"
                    status="loading"
                    loadingTheme="white"
                    title="二维码加载中"
                />
            )}

            {(status === 'failed' || status === 'expired') && (
                <div className={styles.maskContent}>
                    <p className={styles.maskText}>
                        {status === 'expired' ? '二维码已失效，请刷新' : reason || '失败请重试'}
                    </p>
                    <Button
                        type="secondary"
                        size="small"
                        icon={<Icon name="AijBasicShuaxin" size={14} />}
                        onClick={onAction}
                        className={styles.maskAction}
                    >
                        {status === 'expired' ? '刷新' : '重试'}
                    </Button>
                </div>
            )}
        </div>
    );
}
